import React from 'react';

import { Button } from 'antd';
import { t } from 'i18next';

import { useNotification } from 'segments/hooks';

import { useCancelCourtBookingMutation, useConfirmCourtBookingMutation } from '../store/Api';

interface Props {
  bookingsId: number[];
  isConfimed: boolean;
  handleCancel?: () => void;
}

export function ConfirmBookingButton({ bookingsId, isConfimed, handleCancel }: Props) {
  const [cancelBooking, { isSuccess: isCancelSuccess, isLoading: isCancelLoading, isError: isCancelError, error }] = useCancelCourtBookingMutation();
  const [confirmBooking, { isSuccess: isConfirmSuccess, isLoading: isConfirmLoading, isError: isConfirmError }] = useConfirmCourtBookingMutation();

  useNotification({
    isSuccess: isConfimed ? isCancelSuccess : isConfirmSuccess,
    isError: isConfimed ? isCancelError : isConfirmError,
    error
  });

  if (isCancelSuccess) {
    handleCancel?.();
  }

  const handleClick = () => {
    if (isConfimed) {
      for (const bookingId of bookingsId) {
        cancelBooking(bookingId);
      }
    } else {
      for (const bookingId of bookingsId) {
        confirmBooking(bookingId);
      }
    }
  };

  return (
    <Button
      onClick={handleClick}
      disabled={isConfimed ? isCancelLoading : isConfirmLoading}
      type='primary'
      {...isConfimed ? { danger: true } : {}}
    >
      {
        isConfimed ? t('booked-court.titles.cancel-booking', 'Отменить бронь') : t('booked-court.titles.confirm-booking', 'Потвердить бронь')
      }
    </Button>
  );
}

